// extracted by mini-css-extract-plugin
export default {"checkInHistoryTable":"etYdFReKYTljkQu24jGh"};